import React, { Component } from "react";
//import Moment from 'react-moment';
import { css } from "aphrodite/no-important";
import { styles } from "./EnergyServicesHomeStyles";
import Header from "../components/Header";
import EnergyServicesNavigation from "../components/EnergyServicesNavigation";
import Loading from "../components/Loading";
import ApplianceListDisc from "../components/ApplianceListDisc";
import PageTitle from "../components/PageTitle";
import PopupWrapper from "../components/PopupWrapper";
import { appliancesActions } from "../_actions";
import { connect } from "react-redux";

class EnergyServicesAppliances extends Component {
  constructor(props) {
    super(props);
    this.props.dispatch(
      appliancesActions.getDetail(props.authentication.user.user_id)
    );
  }

  render() {
    const { fetchingDetail, detail } = this.props.appliances;

    return (
      <div>
        <Header
          title={"My Home"}
          backTitle={"Dashboard"}
          backHref={"/"}
          isHomeView={true}
        />
        <PageTitle title={"Appliances"} subTitle={detail && detail.subtitle} />
        <EnergyServicesNavigation {...this.props.location} />
        <div className={css([styles.innerNarrow, styles.paddingBottom])}>
          <PopupWrapper />
          {fetchingDetail && <Loading />}
          {!fetchingDetail && detail && detail.appliances && (
            <div>
              {Object.keys(detail.appliances).map((appliance, i) => {
                let item = detail.appliances[appliance];
                return (
                  <ApplianceListDisc
                    title={item.name}
                    state={item.status.state}
                    key={i}
                    size={"small"}
                    id={item.appliance_type_id}
                    icon={item.icon}
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { fetchingDetail } = state.appliances;
  const { alert } = state;
  const appliances = state.appliances;
  const authentication = state.authentication;
  return {
    fetchingDetail,
    alert,
    appliances,
    authentication
  };
}

export default connect(mapStateToProps)(EnergyServicesAppliances);
